/**
 * EFFECTS LIBRARY
 * FANZ
 * DECEMBER 2013
 */

$(document).ready(function(){

	// calculate portfolio based on results
	$("#Form_SurveyForm_action_calc").click(function() {
		
		var er = false;
		var rl;
		r1 = $("input:radio[name ='Q1']:checked").val();
		if (isNaN(r1)){er = true;};
		var r2;
		r2 = $("input:radio[name ='Q2']:checked").val();
		if (isNaN(r2)){er = true;};
		var r3;
		r3 = $("input:radio[name ='Q3']:checked").val();
		if (isNaN(r3)){er = true;};
		var r4;
		r4 = $("input:radio[name ='Q4']:checked").val();
		if (isNaN(r4)){er = true;};
		var r5;
		r5 = $("input:radio[name ='Q5']:checked").val();
		if (isNaN(r5)){er = true;};
		var r6;
		r6 = $("input:radio[name ='Q6']:checked").val();
		if (isNaN(r6)){er = true;};
		var r7;
		r7 = $("input:radio[name ='Q7']:checked").val();
		if (isNaN(r7)){er = true;};
		var r8;
		r8 = $("input:radio[name ='Q8']:checked").val();
		if (isNaN(r8)){er = true;};
		var r9;
		r9 = $("input:radio[name ='Q9']:checked").val();
		var r10;
		r10 = $("input:radio[name ='Q10']:checked").val();
		
		if (isNaN(r9)){er = true;};
		
		if (er){
			alert("Please complete all questions");
		}else{
			var score = Number(r1) + Number(r2) + Number(r3) + Number(r4) + Number(r5) + Number(r6) + Number(r7) + Number(r8) + Number(r9) + Number(r9);
			//alert("Your Score is " +score);
			$('#results').show();
			$('#score').html( score + '/50');
			$('#stable').hide();
			$('#growth').hide();
			if(score < 30){$('#stable').show();};
			if(score > 20){$('#growth').show();};
		}
		return false;
	});
	
});